import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { useAuthContext } from 'src/auth/hooks';
import { useRouter } from 'src/routes/hook';
import Iconify from './iconify';

const LogoutButton = ({ mini }) => {
  const { logout } = useAuthContext();
  const router = useRouter();

  const onLogout = async () => {
    await logout();
    router.push('/auth/login');
    localStorage.removeItem("returnTo");
  };

  if (mini) {
    return (
      <IconButton aria-label="logout" onClick={onLogout}>
        <Tooltip title="Logout">
          <Iconify size={24} icon="ic:baseline-logout" />
        </Tooltip>
      </IconButton>
    );
  }

  return (
    <Button variant="outlined" aria-label="logout" onClick={onLogout}>
      Logout
    </Button>
  );
};

export default LogoutButton;

LogoutButton.propTypes = {
  mini: PropTypes.bool,
};
